import {
  printDocumentScanShortcutSchema,
  weightScanShortcutSchema,
} from "@redotech/redo-model/fulfillments/scan-hotkeys";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const printShortcutBarcodes = {
  name: "printShortcutBarcodes" as const,
  input: z.object({
    presets: z.array(z.object({ id: zExt.objectId() })),
    packages: z.array(z.object({ name: z.string() })),
    print: printDocumentScanShortcutSchema,
    weightScan: weightScanShortcutSchema,
  }),
  output: z.object({ url: z.string(), batchFailed: z.boolean().nullish() }),
};
